import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-moocs',
  templateUrl: './moocs.component.html',
  styleUrls: ['./moocs.component.scss']
})
export class MoocsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
